<div class="flex flex-col md:flex-row min-h-screen bg-white">
  <!-- Sidebar para desktop -->
  <app-sidebar [circleNumber]="1" (backClick)="goBack()" class="bg-teu-purple hidden sm:block relative w-full md:w-[197px] h-[120px] md:h-auto flex-shrink-0 overflow-hidden"></app-sidebar>
  
  <!-- Header para móvil -->
  <app-header [circleNumber]="1" (backClick)="goBack()"></app-header>

  <!-- Main Content -->
  <div class="flex-1 flex flex-col">
    <app-subheader [circleNumber]="2" class="pt-[60px] md:pt-0"></app-subheader>

    <!-- Form Content -->
    <div class="flex-1 px-4 md:px-[100px] lg:px-[200px] pb-12 md:pb-20 max-w-[800px] mx-auto w-full">
      <h1 class="teu-title text-2xl md:text-[32px] mb-2 md:mb-4 text-center">
        Datos Personales
      </h1>
      <p class="teu-subtitle text-lg md:text-xl mb-8 md:mb-12 text-center">
        Completa tu información personal
      </p>

      <form [formGroup]="personalDataForm" class="flex flex-col gap-4 max-w-[500px] mx-auto">
        <!-- CURP -->
        <div class="relative">
          <input
            pInputText
            type="text"
            formControlName="curp"
            placeholder="CURP"
            class="w-full uppercase"
            [class.border-red-500]="hasError('curp')"
            maxlength="18"
          />
          <div *ngIf="hasError('curp')" class="text-red-500 text-xs mt-1 font-inter">
            {{ getErrorMessage('curp') }}
          </div>
          <div class="text-xs text-blue-500 mt-1 text-center">
            ¿No te acuerdas de tu CURP? 
            <a (click)="showCurpHelpModal=true" class="underline">Consúltalo aquí</a>
          </div>
        </div>

        <!-- Nombre(s) -->
        <div class="relative">
          <input
            pInputText
            type="text"
            formControlName="firstName"
            placeholder="Nombre(s)"
            class="w-full"
            [class.border-red-500]="hasError('firstName')"
          />
          <div *ngIf="hasError('firstName')" class="text-red-500 text-xs mt-1 font-inter">
            {{ getErrorMessage('firstName') }}
          </div>
        </div>

        <!-- Apellido paterno -->
        <div class="relative">
          <input
            pInputText
            type="text"
            formControlName="paternalLastName"
            placeholder="Apellido paterno"
            class="w-full"
            [class.border-red-500]="hasError('paternalLastName')"
          />
          <div *ngIf="hasError('paternalLastName')" class="text-red-500 text-xs mt-1 font-inter">
            {{ getErrorMessage('paternalLastName') }}
          </div>
        </div>

        <!-- Apellido materno -->
        <div class="relative">
          <input
            pInputText
            type="text"
            formControlName="maternalLastName"
            placeholder="Apellido materno"
            class="w-full"
            [class.border-red-500]="hasError('maternalLastName')"
          />
          <div *ngIf="hasError('maternalLastName')" class="text-red-500 text-xs mt-1 font-inter">
            {{ getErrorMessage('maternalLastName') }}
          </div>
        </div>

        <!-- RFC y Homoclave en la misma fila -->
        <div class="flex gap-3">
          <div class="flex-1 relative">
            <input
              pInputText
              type="text"
              formControlName="rfc"
              placeholder="RFC"
              class="w-full uppercase"
              [class.border-red-500]="hasError('rfc')"
              maxlength="10"
            />
            <div *ngIf="hasError('rfc')" class="text-red-500 text-xs mt-1 font-inter">
              {{ getErrorMessage('rfc') }}
            </div>
          </div>
          <div class="flex-1 relative">
            <input
              pInputText
              type="text"
              formControlName="homoclave"
              placeholder="Homoclave"
              class="w-full uppercase"
              [class.border-red-500]="hasError('homoclave')"
              maxlength="3"
            />
            <div *ngIf="hasError('homoclave')" class="text-red-500 text-xs mt-1 font-inter">
              {{ getErrorMessage('homoclave') }}
            </div>
          </div>
        </div>

        <!-- Fecha de nacimiento -->
        <div class="relative">
          <label class="block font-inter text-sm font-normal leading-[140%] text-black mb-2">
            Fecha de nacimiento
          </label>
          <input
            pInputText
            type="text"
            formControlName="birthDate"
            placeholder="DD/MM/AAAA"
            class="w-full"
            [class.border-red-500]="hasError('birthDate')"
            maxlength="10"
            (input)="formatDateInput($event)"
            (keypress)="onlyNumbers($event)"
          />
          <div *ngIf="hasError('birthDate')" class="text-red-500 text-xs mt-1 font-inter">
            {{ getErrorMessage('birthDate') }}
          </div>
        </div>

        <!-- Sexo -->
        <div class="relative">
          <p-dropdown
            formControlName="gender"
            [options]="genderOptions"
            placeholder="Sexo"
            optionLabel="label"
            optionValue="value"
            class="w-full"
            [class.border-red-500]="hasError('gender')"
          ></p-dropdown>
          <div *ngIf="hasError('gender')" class="text-red-500 text-xs mt-1 font-inter">
            {{ getErrorMessage('gender') }}
          </div>
        </div>

        <!-- País de nacimiento -->
        <div class="relative">
          <p-dropdown
            formControlName="birthCountry"
            [options]="countryOptions"
            placeholder="País de nacimiento"
            optionLabel="label"
            optionValue="value"
            class="w-full"
            [class.border-red-500]="hasError('birthCountry')"
            [filter]="true"
            filterBy="label"
          ></p-dropdown>
          <div *ngIf="hasError('birthCountry')" class="text-red-500 text-xs mt-1 font-inter">
            {{ getErrorMessage('birthCountry') }}
          </div>
        </div>

        <!-- Estado de nacimiento -->
        <div class="relative">
          <p-dropdown
            formControlName="birthState"
            [options]="stateOptions"
            placeholder="Estado de nacimiento"
            optionLabel="label"
            optionValue="value"
            class="w-full"
            [class.border-red-500]="hasError('birthState')"
            [filter]="true"
            filterBy="label"
          ></p-dropdown>
          <div *ngIf="hasError('birthState')" class="text-red-500 text-xs mt-1 font-inter">
            {{ getErrorMessage('birthState') }}
          </div>
        </div>

        <!-- Estado civil -->
        <div class="relative">
          <p-dropdown
            formControlName="maritalStatus"
            [options]="maritalStatusOptions"
            placeholder="Estado civil"
            optionLabel="label"
            optionValue="value"
            class="w-full"
            [class.border-red-500]="hasError('maritalStatus')"
          ></p-dropdown>
          <div *ngIf="hasError('maritalStatus')" class="text-red-500 text-xs mt-1 font-inter">
            {{ getErrorMessage('maritalStatus') }}
          </div>
        </div>

        <!-- Nacionalidad 
        <div class="relative">
          <p-dropdown
            formControlName="nationality"
            [options]="nationalityOptions"
            placeholder="Nacionalidad"
            optionLabel="label"
            optionValue="value"
            class="w-full"
            [class.border-red-500]="hasError('nationality')"
            [filter]="true"
            filterBy="label"
          ></p-dropdown>
          <div *ngIf="hasError('nationality')" class="text-red-500 text-xs mt-1 font-inter">
            {{ getErrorMessage('nationality') }}
          </div>
        </div>-->

        <!-- Botón Confirmar -->
        <button
          type="button"
          class="btn-primary w-full max-w-[300px] h-[46px] mt-6 mx-auto"
          [disabled]="personalDataForm.invalid"
          [class.opacity-50]="personalDataForm.invalid"
          [class.cursor-not-allowed]="personalDataForm.invalid"
          (click)="onSubmit()"
        >
          Confirmar
        </button>
      </form>
    </div>
  </div>

  <app-general-modal
  [(visible)]="showCurpHelpModal"
  [showFooter]="false"
  [closable]="false"
  [modalStyle]="{ width: '92vw', maxWidth: '520px' }"
  contentClass="flex flex-col gap-5 items-center text-center p-6 sm:p-8"
  (modalHide)="closeCurpHelp()">

  <!-- Título -->
  <h2 class="text-2xl sm:text-3xl font-extrabold text-gray-900">
    Consulta tu CURP
  </h2>

  <!-- Descripción -->
  <p class="text-base text-gray-700 leading-relaxed max-w-md">
    Ten tu INE a la mano para poder consultar tu CURP.
  </p>

  <!-- Imagen con resaltado -->
  <div class="w-full max-w-md">
    <div class="relative rounded-2xl overflow-hidden shadow-xl bg-white">
      <div [innerHTML]="curpHelpImgSafe"></div>

      <!-- Resaltado (ajustable) -->
      <div class="absolute"  aria-hidden="true">
        <!-- Borde azul -->
        <div class="w-full h-full rounded-md border-[3px] border-blue-600"></div>
        <!-- Halo amarillo (ligeramente más grande) -->
        <div class="absolute rounded-md" style="inset:-6px; border:6px solid #fde047;"></div>
      </div>
    </div>
  </div>

  <!-- CTA -->
  <div class="w-full max-w-md">
    <button
      type="button"
      class="w-full bg-indigo-500 hover:bg-indigo-600 text-white font-semibold py-3.5 rounded-xl transition-all duration-200 shadow-lg active:scale-95"
      (click)="closeCurpHelp()">
      Aceptar
    </button>
  </div>
</app-general-modal>


</div>
